const STORAGE_KEY = 'hatched_admin_session_v1';
const SHOULD_PERSIST = process.env.NODE_ENV === 'test';

let currentSession = null;
const listeners = new Set();

function notify() {
  listeners.forEach((listener) => {
    try {
      listener(currentSession);
    } catch (_error) {
      // Keep state propagation safe for all listeners.
    }
  });
}

function safeParse(rawValue) {
  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (_error) {
    return null;
  }
}

function loadSession() {
  if (!SHOULD_PERSIST || typeof window === 'undefined') {
    return null;
  }

  return safeParse(window.sessionStorage.getItem(STORAGE_KEY));
}

function persistSession(session) {
  if (typeof window === 'undefined') {
    return;
  }

  if (!session) {
    window.sessionStorage.removeItem(STORAGE_KEY);
    return;
  }

  if (!SHOULD_PERSIST) {
    return;
  }

  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

currentSession = loadSession();

export function getAdminSession() {
  return currentSession;
}

export function setAdminSession(nextSession) {
  currentSession = nextSession || null;
  persistSession(currentSession);
  notify();
}

export function clearAdminSession() {
  setAdminSession(null);
}

export function subscribeAdminSession(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
